import React, { useEffect, useState } from "react";
import { get } from "lodash";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Toggle from "@amzn/meridian/toggle";
import Text from "@amzn/meridian/text";
import { formatStatus } from "../../table/utils";

interface IIncomeEnableSpaceProps {
    data: any;
    isEditing: boolean;
    spaceId: string;
    handleInputChange: any;
}

const getSpacePath = (spaceId: string) =>
    `appealDetails.appealApproachCalculationData.income.spaces.${spaceId}`;

export const SpaceToggleComponent: React.FC<IIncomeEnableSpaceProps> = ({
    data,
    isEditing,
    spaceId,
    handleInputChange,
}) => {
    const spacePath = getSpacePath(spaceId);

    const [checked, setChecked] = useState(get(data, `${spacePath}.enable`, true));

    const status = get(data, `${spacePath}.status`, "");

    useEffect(() => {
        const isIncluded = get(data, `${spacePath}.enable`);
        setChecked(isIncluded);
    }, [data, spaceId, spacePath]);

    const handleToggleChange = (newValue: boolean) => {
        setChecked(newValue);
        handleInputChange(`${spacePath}.enable`, newValue);
    };

    return (
        <Row width="100%" widths="fill">
            <Column>
                <Row spacing="200">
                    <Toggle checked={checked} onChange={handleToggleChange} disabled={!isEditing} />
                    <Text>Include this space in the appeals package</Text>
                </Row>
            </Column>
            <Column alignmentHorizontal="end">
                <Row spacing="200">
                    <Text>Space status:</Text>
                    {formatStatus(status)}
                </Row>
            </Column>
        </Row>
    );
};
